import { TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AdapterJalali from '@date-io/date-fns-jalali';
import AdapterHijri from '@date-io/hijri';
import { useState } from 'react';
import { ar } from 'date-fns/locale';
import moment from 'moment-hijri';
import useSettings from 'src/hooks/useSettings';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import af from 'date-fns/locale/af/index';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface Props {
  control: any;
  label: any;
  name: any;
  targetName?: any;
  isDisablePast?: any;
  isDisableFuture?: any;
  size?: any;
  views?: any;
  showAsterisk?: boolean;
  disabled?: boolean;
  sx?: React.CSSProperties; // Optional styling prop
  // value?: string;
}


export default function LocalizDatePicker({
  control,
  label,
  name,
  targetName,
  isDisablePast,
  isDisableFuture,
  size,
  showAsterisk,
  views,
  disabled,
  sx = {},
}: // value,
  Props) {
  const { dateFormat } = useSettings();

  // Example of using the custom

  const [open, setOpen] = useState(false);

  return (
    <>
      {dateFormat === 'GD' ? (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <DatePicker
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                views={views}
                disabled={disabled}

                label={
                  <Typography>
                    {label}{' '}
                    {showAsterisk && <span style={{ color: 'red', fontWeight: 'bold' }}> *</span>}
                  </Typography>
                }
                value={field.value}
                disableHighlightToday={true}
                disablePast={ isDisablePast === true ? true : false}
                disableFuture={ isDisableFuture === true ? true : false}

                onChange={(newValue) => {
                  field.onChange(newValue);
                  if (targetName) {
                    control.setValue(targetName, newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onClick={(e) => setOpen(true)}
                    fullWidth
                    size={size}
                    sx={{ ...sx }}
                    error={!!error}
                    helperText={error?.message}
                    disabled={disabled}
                  // value={value}
                  />
                )}
              />
            )}
          />
        </LocalizationProvider>
      ) : dateFormat === 'Shamsi' ? (
        <LocalizationProvider dateAdapter={AdapterJalali} adapterLocale={af}>
          <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <DatePicker
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                views={views}
                disabled={disabled}
                label={
                  <Typography>
                    {label}{' '}
                    {showAsterisk && <span style={{ color: 'red', fontWeight: 'bold' }}> *</span>}
                  </Typography>
                }
                value={field.value}
                disableHighlightToday={true}
                disablePast={ isDisablePast === true ? true : false}
                disableFuture={ isDisableFuture === true ? true : false}
                onChange={(newValue) => {
                  field.onChange(newValue);
                  if (targetName) {
                    control.setValue(targetName, newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onClick={(e) => setOpen(true)}
                    fullWidth
                    size={size}
                    error={!!error}
                    helperText={error?.message}
                    disabled={disabled}
                  />
                )}
              />
            )}
          />
        </LocalizationProvider>
      ) : (
        <LocalizationProvider dateAdapter={AdapterHijri} adapterLocale={ar}>
          <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <DatePicker
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                disabled={disabled}
                label={
                  <Typography>
                    {label}{' '}
                    {showAsterisk && <span style={{ color: 'red', fontWeight: 'bold' }}> *</span>}
                  </Typography>
                }
                minDate={moment(new Date(1938, 0, 1))}
                maxDate={moment(new Date(2075, 11, 31))}
                value={field.value}
                disableHighlightToday={true}
                disablePast={ isDisablePast === true ? true : false}
                disableFuture={ isDisableFuture === true ? true : false}
                onChange={(newValue) => {
                  field.onChange(newValue);
                  if (targetName) {
                    control.setValue(targetName, newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onClick={(e) => setOpen(true)}
                    fullWidth
                    size={size}
                    error={!!error}
                    helperText={error?.message}
                    disabled={disabled}
                  />
                )}
              />
            )}
          />
        </LocalizationProvider>
      )}
    </>
  );
}
